module.exports = __webpack_public_path__ + "img/vikings-2.5638a5dc.png";